import { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, Cell } from "recharts";
import { pct } from "@/lib/format";

const AXIS_TICK_X = { fill: "#64748B", fontSize: 11, fontFamily: "JetBrains Mono" };
const AXIS_TICK_Y = { fill: "#94A3B8", fontSize: 11, fontFamily: "JetBrains Mono" };
const AXIS_LINE_X = { stroke: "#E2E8F0" };
const CURSOR_FILL = { fill: "#F1F5F9" };
const TOOLTIP_STYLE = { background: "#0F172A", border: "none", color: "#fff", fontSize: 12, fontFamily: "JetBrains Mono" };
const BAR_MARGIN = { top: 10, right: 10, left: 0, bottom: 10 };
const BAR_RADIUS = [2, 2, 0, 0];

const formatTick = (v) => `${v.toFixed(0)}%`;
const formatTooltip = (value) => [pct(value), "ROI"];

export default function SensitivityChart({ results, currency, height = 240 }) {
  const data = useMemo(() => ([
    { name: "Conservative", roi: results.conservative.roi_pct, fill: "#94A3B8" },
    { name: "Base", roi: results.base.roi_pct, fill: "#0055FF" },
    { name: "Optimistic", roi: results.optimistic.roi_pct, fill: "#10B981" },
  ]), [results]);

  const containerStyle = useMemo(() => ({ width: "100%", height }), [height]);

  return (
    <div style={containerStyle}>
      <ResponsiveContainer>
        <BarChart data={data} margin={BAR_MARGIN}>
          <XAxis
            dataKey="name"
            tick={AXIS_TICK_X}
            axisLine={AXIS_LINE_X}
            tickLine={false}
          />
          <YAxis
            tick={AXIS_TICK_Y}
            axisLine={false}
            tickLine={false}
            tickFormatter={formatTick}
          />
          <Tooltip
            cursor={CURSOR_FILL}
            contentStyle={TOOLTIP_STYLE}
            formatter={formatTooltip}
          />
          <Bar dataKey="roi" radius={BAR_RADIUS}>
            {data.map((d) => (
              <Cell key={d.name} fill={d.roi >= 0 ? d.fill : "#EF4444"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
